<template>
	<div class="main-contents">
        <div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>회원가입 완료</span>
				</div>
            </div>
        </div>
        <div class="mem_container">
            <div class="main-box">                   
                <div class="mem_contents_body">
                    <div class="info-box">
                        <div class="phone-img">
                            <div class="phone-info completion " v-if="title == '기술인재'">
                                <span>
                                    그레이트프로 얼라이언스 합류를 환영합니다.
                                </span>
                                <br />
                                지금 이력서를 등록하시면,<br />
                                든든한 파트너들과 함께 검증된 프로젝트에 참여하실 수 있습니다.
                            </div>
                            <div class="phone-info completion " v-else>
                                <span>
                                    그레이트프로 얼라이언스 합류를 환영합니다.
                                </span>
                                <br />
                                성공적인 프로젝트를 위하여 인재평가와 검증 및 관리를 통하여<br/>
                                검증된 IT전문인재들을 기업의 프로젝트와 연결해 드립니다.                                    
                            </div>
                        </div>
                        <div class="btn-login_completion" @click="pageMove()">로그인</div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { signupCompleteMeta } from '@/utils/meta';
export default {
    metaInfo : signupCompleteMeta,
	data() {
		return {
			title : '',
		}
	},

	beforeMount() {
		if(this.$route.params) {
			this.title = this.$route.params.forwardData;
		}
	},

	methods : {
		pageMove() {
            this.$router.replace({name: 'MEM001M01'});
		}
	}
}
</script>